"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buttonsContainer = exports.alignItems = exports.titleStyle = exports.contentStyleMobile = exports.contentStyleDesktop = exports.iconStyleMobile = exports.iconStyleDesktop = exports.rootStyleMobile = exports.rootStyleDesktop = void 0;

var _reactEmotion = require("react-emotion");

var rootStyleDesktop =
/*#__PURE__*/
(0, _reactEmotion.css)("padding:48px 38px;position:relative;");
exports.rootStyleDesktop = rootStyleDesktop;
var rootStyleMobile =
/*#__PURE__*/
(0, _reactEmotion.css)("width:100%;position:relative;height:100%;");
exports.rootStyleMobile = rootStyleMobile;

var iconStyleDesktop = function iconStyleDesktop(theme) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("width:13.4px;height:13.4px;position:absolute;right:21px;top:21px;cursor:pointer;fill:", theme.color.dark.white, ";")
  );
};

exports.iconStyleDesktop = iconStyleDesktop;

var iconStyleMobile = function iconStyleMobile(theme) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("width:14px;height:14px;position:absolute;right:14px;top:21px;fill:", theme.color.dark.white, ";")
  );
};

exports.iconStyleMobile = iconStyleMobile;

var contentStyleDesktop = function contentStyleDesktop(theme) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("display:flex;overflow-y:scroll;padding:0 10px;&::-webkit-scrollbar{height:8px;width:0px;border-radius:4px;background-color:", theme.color.dark.white0_06, ";}&::-webkit-scrollbar-thumb{height:8px;border-radius:4px;background-color:", theme.color.dark.mercury, ";}")
  );
};

exports.contentStyleDesktop = contentStyleDesktop;
var contentStyleMobile =
/*#__PURE__*/
(0, _reactEmotion.css)("overflow:scroll;height:calc(100% - 130px);width:100%;position:absolute;top:60px;&::-webkit-scrollbar{width:0px;background:transparent;height:0px;}");
exports.contentStyleMobile = contentStyleMobile;
var titleStyle =
/*#__PURE__*/
(0, _reactEmotion.css)("padding:21px 15px;font-size:12px;font-weight:500;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:0.86px;position:fixed;");
exports.titleStyle = titleStyle;
var alignItems =
/*#__PURE__*/
(0, _reactEmotion.css)("display:inline-flex;justify-content:center;align-items:center;box-sizing:border-box;");
exports.alignItems = alignItems;
var buttonsContainer =
/*#__PURE__*/
(0, _reactEmotion.css)("margin:17px 0;display:flex;justify-content:space-between;position:absolute;width:calc(100% - 30px);top:calc(100% - 70px);left:15px;");
exports.buttonsContainer = buttonsContainer;